import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {IFuncionario} from '../interfaces/funcionario/ifuncionario';
import {Observable, map, BehaviorSubject} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FuncionarioService {
  filter !: IFuncionarioFilter;
  api = `${environment.url}`
  filterQueryParams: string = "";

  private totalItemsSubject = new BehaviorSubject<number>(0);
  totalItems$ = this.totalItemsSubject.asObservable();

  constructor(private http: HttpClient) {
  }

  get(totalPages: string = "") {
    let queryParams: any;
    if (this.filter) {
      let urlParams = new URLSearchParams();
      if (this.filter?.profession) {
        this.filter.profession.forEach(id => {
          urlParams.append('profession', id);
        });
      }
      if (this.filter?.unit) {
        this.filter.unit.forEach(id => {
          urlParams.append('units[]', id);
        });
      }
      if (this.filter?.name) {
        urlParams.append('name', this.filter.name);
      }
      queryParams = "?" + urlParams.toString();
    }

    if (this.filterQueryParams.length > 0) {
      queryParams = this.filterQueryParams;
    }

    const itemsPerPage = totalPages || '1000';

    return this.http
      .get(`${this.api}/employees${queryParams}`)
      .pipe(map((res: any) => {
          this.totalItemsSubject.next(res['hydra:totalItems'] ?? 0)
          return res['hydra:member']
        }
      )) as Observable<IFuncionario[]>;
  }

  post(form: IFuncionario) {
    return this.http.post(
      `${this.api}/employees`,
      form
    ) as Observable<IFuncionario>;
  }

  getById(form: IFuncionario, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(`${this.api}/employees/${id}`, form, {
      headers: headers,
    }) as Observable<IFuncionario>;
  }

  edit(req: IFuncionario, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(
      `${this.api}/employees/${id}`,
      req,
      {headers: headers}
    ) as Observable<IFuncionario>;
  }

  delete(id: number) {
    return this.http.delete(
      `${this.api}/employees/${id}`
    ) as Observable<IFuncionario>;
  }

  setFilter(filter: IFuncionarioFilter) {
    this.filter = filter;
  }

  setFilterQueryParams(filterQuqeryParams: string) {
    this.filterQueryParams = filterQuqeryParams;
  }
}

export interface IFuncionarioFilter {
  profession: string [],
  unit: string[],
  name: string
}

export class FuncionarioFilter {
  profession !: string [];
  unit!: string[];
  name!: string;
}
